import { useLazyQuery } from '@apollo/client';
import { ErrorPanel } from '@mainstage/core-components';
import { CircularProgress, List } from '@material-ui/core';
import { FC, useEffect } from 'react';
import {
  GOVERNANCE_ENTITIES,
  GovernanceEntitiesQueryType,
} from '../../../graphql/governanceEntities';
import { Test } from '../types';
import { TaskListItem } from './TaskListItem/TaskListItem';

interface Props {
  test: Test;
}

export const TaskDisclosure: FC<Props> = ({ test }) => {
  const [fetchPolicies, { loading, error, data }] =
    useLazyQuery<GovernanceEntitiesQueryType>(GOVERNANCE_ENTITIES, {
      variables: {
        ids: test.tasks
          .filter(t => !!t.governanceEntityId)
          .map(p => p.governanceEntityId),
      },
    });

  useEffect(() => {
    if (!data) {
      fetchPolicies();
    }
  }, [fetchPolicies, data]);

  return (
    <div>
      {loading && (
        <div>
          <CircularProgress />
        </div>
      )}
      {error && <ErrorPanel error={error} />}
      <List aria-label="detail list">
        {!loading &&
          !error &&
          test.tasks.map((t, i) => (
            <TaskListItem
              key={`${t.id}_${i}`}
              task={t}
              governanceEntities={data?.cgp_governance_entity || []}
            />
          ))}
      </List>
    </div>
  );
};
